<template>
    <div style="width: 95%;">
        <template v-if="loading>0">
             <Loader :delay="0"></Loader>
        </template>
        <template v-else>
        <b-row>
            <b-col>
              <b-form>
                <b-form-group style="font-size: 1rem;" label="IDI">
                  <b-form-input v-model="id" disabled></b-form-input>
                </b-form-group>
              </b-form>
            </b-col>
            <b-col v-if="type==='caldera'">
              <b-form>
                <b-form-group style="font-size: 1rem;" label="Código">
                  <b-form-input v-model="detalles.codigo" disabled></b-form-input>
                </b-form-group>
              </b-form>
            </b-col>
            <b-col>
              <b-form>
                <b-form-group style="font-size: 1rem;" label="Categoria GN">
                  <b-form-select  data-vv-scope="identificacion" v-validate="'required'" name="Categoria GN" @input="loadTipo(false)" v-model="detalles['id_categoria_gn_'+type].id" :options="categoria_gn_options" class="mb-3" :text-field="'categoria_gn_'+type" value-field="id" :disabled="!hasPermision('B')"/>
                  <span class="error">{{ errors.first('identificacion.Categoria GN') }}</span>
                  <!-- <b-form-input v-model="detalles['id_categoria_gn_'+type]['categoria_gn_'+type]" :disabled="!hasPermision('B')"></b-form-input> -->
                </b-form-group>
                <!-- <b-form-group v-if="type==='caldera'" style="font-size: 1rem;" label="Categoria GN">
                  <b-form-input v-model="feature.properties.id_categoria_gn_caldera.categoria_gn_caldera" :disabled="!hasPermision('B')"></b-form-input>
                </b-form-group> -->
              </b-form>
            </b-col>
            <b-col>
              <b-form>
                <b-form-group style="font-size: 1rem;" label="Tipo establecimiento">
                  <!-- <b-form-input v-model="detalles['id_tipo_establecimiento_gn_'+type].tipo" :disabled="!hasPermision('B')"></b-form-input> -->
                  <!-- <b-form-select  data-vv-scope="identificacion" v-validate="'required'" name="Tipo establecimiento" text-field="tipo" value-field="id" v-model="detalles['id_tipo_establecimiento_gn_'+type].id" :options="tipo_establecimiento_gn_options" class="mb-3" :disabled="tipo_establecimiento_gn_options.length===0 || !hasPermision('B')"/> -->

                  <multiselect
                    placeholder="Seleccionar una opción"
                    selectedLabel="Seleccionada"
                    deselect-label="Click o enter para deseleccionar"
                    select-label="Click o enter para seleccionar"
                    tag-placeholder="Seleccionar"
                    v-model="detalles['id_tipo_establecimiento_gn_'+type]"
                    :options="tipo_establecimiento_gn_options"
                    label="tipo" track-by="id"
                    @close='closedTipoEstablecimiento'
                    :disabled="tipo_establecimiento_gn_options.length===0 || !hasPermision('B')">
                  </multiselect>

                  <span class="error">{{ customErrors['tipo_establecimiento'] }}</span>
                </b-form-group>
                <!-- <b-form-group v-if="type==='caldera'" style="font-size: 1rem;" label="Tipo establecimiento">
                  <b-form-input v-model="feature.properties.id_tipo_establecimiento_caldera.tipo" :disabled="!hasPermision('B')"></b-form-input>
                </b-form-group> -->
              </b-form>
            </b-col>
          </b-row>
          <b-row v-if="type==='comercial'">
            <b-col>
              <b-form>
                <b-form-group style="font-size: 1rem;" label="Nombre establecimiento">
                    <b-form-input  data-vv-scope="identificacion" v-validate="'required'" name="Nombre establecimiento" v-model="detalles.nombre" :disabled="!hasPermision('B')"></b-form-input>
                    <span class="error">{{ errors.first('identificacion.Nombre establecimiento') }}</span>
                </b-form-group>
              </b-form>
            </b-col>
            <b-col>
              <b-form>
                <b-form-group style="font-size: 1rem;" label="Código CNAE">
                    <!-- <b-form-input v-model="detalles.codigo_cnae" :disabled="!hasPermision('B')"></b-form-input> -->
                    <!--<b-form-select v-model="detalles.codigo_cnae" :options="cnae_options" class="mb-3" text-field="descripcion" value-field="id" :disabled="!hasPermision('B')"/>-->

                    <multiselect
                    placeholder="Seleccionar una opción"
                    selectedLabel="Seleccionada"
                    deselect-label="Click o enter para deseleccionar"
                    select-label="Click o enter para seleccionar"
                    tag-placeholder="Seleccionar"
                    :custom-label="customLabelCNAE"
                    v-model="detalles.codigo_cnae"
                    :options="cnae_options"
                    label="descripcion" track-by="id"
                    :disabled="!hasPermision('B')">
                  </multiselect>

                </b-form-group>
              </b-form>
            </b-col>
          </b-row>
          <b-row v-else-if="type==='caldera'">
            <b-col>
              <b-form>
                <b-form-group style="font-size: 1rem;" label="Tipo caldera">
                    <b-form-input  data-vv-scope="identificacion" v-validate="'required'" name="Tipo caldera" v-model="detalles_ext.caldera_centralizada" :disabled="!hasPermision('B')"></b-form-input>
                    <span class="error">{{ errors.first('identificacion.Tipo caldera') }}</span>
                </b-form-group>
              </b-form>
            </b-col>
            <b-col>
              <b-form>
                <b-form-group style="font-size: 1rem;" label="Mercado">
                    <b-form-input  data-vv-scope="identificacion" v-validate="'required'" name="Mercado" v-model="detalles_ext.mercado" :disabled="!hasPermision('B')"></b-form-input>
                    <span class="error">{{ errors.first('identificacion.Mercado') }}</span>
                </b-form-group>
              </b-form>
            </b-col>
            <b-col>
              <b-form>
                <b-form-group style="font-size: 1rem;" label="Gas en finca">
                    <b-form-input  data-vv-scope="identificacion" v-validate="'required'" name="Gas en finca" v-model="detalles.id_gas_en_finca.gas" :disabled="!hasPermision('B')"></b-form-input>
                    <span class="error">{{ errors.first('identificacion.Gas en finca') }}</span>
                </b-form-group>
              </b-form>
            </b-col>
            <b-col>
              <b-form>
                <b-form-group style="font-size: 1rem;" label="Es cliente">
                    <b-form-input v-if="detalles.cliente" name="Es cliente" value="SÍ" :disabled="!hasPermision('B')"></b-form-input>
                    <b-form-input v-else name="Es cliente" value="NO" :disabled="!hasPermision('B')"></b-form-input>
                </b-form-group>
              </b-form>
            </b-col>
          </b-row>
          <b-row v-if="type==='caldera'">
            <b-col>
              <b-form>
                <b-form-group style="font-size: 1rem;" label="Dirección caldera principal">
                    <b-form-input  data-vv-scope="identificacion" v-validate="'required'" name="Dirección caldera principal" :value="direccionCaldera" :disabled="!hasPermision('B')"></b-form-input>
                    <span class="error">{{ errors.first('identificacion.Dirección caldera principal') }}</span>
                </b-form-group>
              </b-form>
            </b-col>
          </b-row>
          <b-row v-if="type==='caldera'">
            <b-col>
              <b-form>
                <b-form-group style="font-size: 1rem;" label="PS con CC en finca">
                    <b-form-input  data-vv-scope="identificacion" v-validate="'required'" name="PS con CC en finca" v-model="detalles_ext.n_usuarios_finca_principal" :disabled="!hasPermision('B')"></b-form-input>
                    <span class="error">{{ errors.first('identificacion.PS con CC en finca') }}</span>
                </b-form-group>
              </b-form>
            </b-col>
            <b-col>
              <b-form>
                <b-form-group style="font-size: 1rem;" label="PS con CC en suministradas">
                    <b-form-input  data-vv-scope="identificacion" v-validate="'required'" name="PS con CC en suministradas" v-model="detalles_ext.n_usuarios_fincas_suministradas" :disabled="!hasPermision('B')"></b-form-input>
                    <span class="error">{{ errors.first('identificacion.PS con CC en suministradas') }}</span>
                </b-form-group>
              </b-form>
            </b-col>
            <b-col>
              <b-form>
                <b-form-group style="font-size: 1rem;" label="PS total CC">
                    <b-form-input  data-vv-scope="identificacion" v-validate="'required'" name="PS total CC" v-model="detalles_ext.n_usuarios_totales" :disabled="!hasPermision('B')"></b-form-input>
                    <span class="error">{{ errors.first('identificacion.PS total CC') }}</span>
                </b-form-group>
              </b-form>
            </b-col>
          </b-row>
          <b-row>
              <b-col>
                  <b-form>
                    <b-form-group style="font-size: 1rem;" label="Provincia">
                        <!-- <b-form-input v-model="detalles.provincia" :disabled="!hasPermision('B')"></b-form-input> -->
                        <b-form-select  data-vv-scope="identificacion" v-validate="'required'" name="Provincia" @input="loadMunicipio(false)" v-model="detalles.codigo_provincia_zeus" :options="provincias_options" class="mb-3" text-field="entity_name" value-field="id" :disabled="!hasPermision('B')"/>
                        <span class="error">{{ errors.first('identificacion.Provincia') }}</span>
                    </b-form-group>
                </b-form>
              </b-col>
              <b-col>
                  <b-form>
                    <b-form-group style="font-size: 1rem;" label="Municipio">
                        <!-- <b-form-input v-model="detalles.municipio" :disabled="!hasPermision('B')"></b-form-input> -->
                        <b-form-select  data-vv-scope="identificacion" v-validate="'required'" name="Municipio" @input="loadPoblacion(false)" text-field="entity_name" value-field="id" v-model="detalles.codigo_municipio_zeus" :options="municipio_options" class="mb-3" :disabled="municipio_options.length===0 || !hasPermision('B')"/>
                        <span class="error">{{ errors.first('identificacion.Municipio') }}</span>
                    </b-form-group>
                </b-form>
              </b-col>
              <b-col>
                  <b-form>
                    <b-form-group style="font-size: 1rem;" label="Población">
                        <!-- <b-form-input v-model="detalles.poblacion" :disabled="!hasPermision('B')"></b-form-input> -->
                        <b-form-select  data-vv-scope="identificacion" v-validate="'required'" name="Población" text-field="entity_name" value-field="id" v-model="detalles.codigo_poblacion_zeus" :options="poblacion_options" class="mb-3" :disabled="poblacion_options.length===0 || !hasPermision('B')"/>
                        <span class="error">{{ errors.first('identificacion.Población') }}</span>
                    </b-form-group>
                </b-form>
              </b-col>
          </b-row>
          <b-row>
              <b-col>
                  <b-form>
                    <b-form-group style="font-size: 1rem;" label="Dirección no estructurada">
                        <b-form-input  data-vv-scope="identificacion" v-validate="direccionValidate" name="Dirección no estructurada" v-model="detalles.direccion_no_estructurada" :disabled="!hasPermision('B')"></b-form-input>
                        <span class="error">{{ errors.first('identificacion.Dirección no estructurada') }}</span>
                    </b-form-group>
                </b-form>
              </b-col>
              <b-col>
                  <b-form>
                    <b-form-group style="font-size: 1rem;" label="Código postal">
                        <b-form-input  data-vv-scope="identificacion" v-validate="'required|cod_postal'" name='Código postal' v-model="detalles.codigo_postal" :disabled="!hasPermision('B')"></b-form-input>
                        <span class="error">{{ errors.first('identificacion.Código postal') }}</span>
                    </b-form-group>
                </b-form>
              </b-col>
          </b-row>
          <b-row>
              <b-col>
                  <b-form>
                    <b-form-group style="font-size: 1rem;" label="Tipo vía">
                        <!-- <b-form-input v-model="detalles.tipo_via" :disabled="!hasPermision('B')"></b-form-input> -->
                        <b-form-select  data-vv-scope="identificacion" v-validate="direccionValidate" name="Tipo vía" v-model="detalles.tipo_via" :options="tipo_via_options" class="mb-3" text-field="name_type" value-field="name_type" :disabled="!hasPermision('B')"/>
                        <span class="error">{{ errors.first('identificacion.Tipo vía') }}</span>
                    </b-form-group>
                </b-form>
              </b-col>
              <b-col cols="6">
                  <b-form>
                    <b-form-group style="font-size: 1rem;" label="Nombre vía" class="autocomplete">
                        <b-form-input autocomplete="off" @input="loadNames"  data-vv-scope="identificacion" v-validate="direccionValidate" name="Nombre vía" v-model="detalles.nombre_via" :disabled="!hasPermision('B')"></b-form-input>
                        <div v-if="show_names && type==='comercial'" class="autocomplete-items">
                          <div @click="setElement(element)" v-for="(element, index) in names_suggestions" v-bind:key="index">
                            {{element.street_type.name_type}} {{element.street_name}} ({{element.postal_code_address}})
                            <!-- <strong>Sp</strong>ain<input type="hidden" value="Spain"> -->
                          </div>
                        </div>
                        <span class="error">{{ errors.first('identificacion.Nombre vía') }}</span>
                    </b-form-group>
                </b-form>
              </b-col>
              <b-col>
                  <b-form>
                    <b-form-group style="font-size: 1rem;" label="Número">
                        <b-form-input  data-vv-scope="identificacion" v-validate="direccionValidate" name="Número" v-model="detalles.numero" :disabled="!hasPermision('B')"></b-form-input>
                        <span class="error">{{ errors.first('identificacion.Número') }}</span>
                    </b-form-group>
                </b-form>
              </b-col>
              <b-col>
                  <b-form>
                    <b-form-group style="font-size: 1rem;" label="Anexo">
                        <b-form-input v-model="detalles.anexo" :disabled="!hasPermision('B')"></b-form-input>
                    </b-form-group>
                </b-form>
              </b-col>
          </b-row>
          <b-row>
              <b-col>
                  <b-form>
                    <b-form-group style="font-size: 1rem;" label="Latitud">
                        <b-form-input  data-vv-scope="identificacion" v-validate="'required'" name="Latitud" v-model="detalles.latitud_original" :disabled="!hasPermision('B')"></b-form-input>
                        <span class="error">{{ errors.first('identificacion.Latitud') }}</span>
                    </b-form-group>
                </b-form>
              </b-col>
              <b-col>
                  <b-form>
                    <b-form-group style="font-size: 1rem;" label="Longitud">
                        <b-form-input  data-vv-scope="identificacion" v-validate="'required'" name="Longitud" v-model="detalles.longitud_original" :disabled="!hasPermision('B')"></b-form-input>
                        <span class="error">{{ errors.first('identificacion.Longitud') }}</span>
                    </b-form-group>
                </b-form>
              </b-col>
              <b-col>
                  <b-form>
                    <b-form-group style="font-size: 1rem;" label="Precisión coordenadas">
                        <!-- <b-form-input v-model="detalles.id_precision_coordenada.tipo_precision" :disabled="!hasPermision('B')"></b-form-input> -->
                        <b-form-select  data-vv-scope="identificacion" v-validate="'required'" name="Precisión coordenadas" v-model="detalles.id_precision_coordenada.id" :options="coordenadas_options" class="mb-3" text-field="tipo_precision" value-field="id" :disabled="!hasPermision('B')"/>
                        <span class="error">{{ errors.first('identificacion.Precisión coordenadas') }}</span>
                    </b-form-group>
                </b-form>
              </b-col>
          </b-row>
          <b-row>
              <b-col>
                  <b-form>
                    <b-form-group style="font-size: 1rem;" label="Distancia a red dist. en servicio (m)">
                        <b-form-input v-model="detalles.in_service_mains_distance" disabled></b-form-input>
                    </b-form-group>
                </b-form>
              </b-col>
              <b-col>
                  <b-form>
                    <b-form-group style="font-size: 1rem;" label="Distancia a red dist. no abandonada (m)">
                        <b-form-input v-model="detalles.not_abandoned_mains_distance" disabled></b-form-input>
                    </b-form-group>
                </b-form>
              </b-col>
              <b-col>
                  <b-form>
                    <b-form-group style="font-size: 1rem;" label="Distancia a red AP en servicio (m)">
                        <b-form-input v-model="detalles.high_press_main_in_service_dis" disabled></b-form-input>
                    </b-form-group>
                </b-form>
              </b-col>
              <b-col>
                  <b-form>
                    <b-form-group style="font-size: 1rem;" label="Distancia a red AP no abandonada (m)">
                        <b-form-input v-model="detalles.high_pressure_mains_distance" disabled></b-form-input>
                    </b-form-group>
                </b-form>
              </b-col>
          </b-row>
          <b-row>
            <b-col style="text-align: right;" v-if="hasPermision('B')">
                <b-button @click="cancel">Cancelar</b-button>
                <b-button @click="save($event)">Guardar</b-button>
            </b-col>
        </b-row>
        <br>
        </template>
    </div>
</template>

<style>
.autocomplete {
  /*the container must be positioned relative:*/
  position: relative;
  /* display: inline-block; */
}
.autocomplete-items {
  position: absolute;
  border: 1px solid #d4d4d4;
  border-bottom: none;
  border-top: none;
  z-index: 99;
  /*position the autocomplete items to be the same width as the container:*/
  top: 100%;
  left: 0;
  right: 0;
}
.autocomplete-items div {
  padding: 10px;
  cursor: pointer;
  background-color: #fff;
  border-bottom: 1px solid #d4d4d4;
}
.autocomplete-items div:hover {
  /*when hovering an item:*/
  background-color: #e9e9e9;
}
.autocomplete-active {
  /*when navigating through the items using the arrow keys:*/
  background-color: DodgerBlue !important;
  color: #ffffff;
}
</style>

<script>
import Loader from '@/components/Layout/Loader.vue';

import { Validator } from 'vee-validate';

var debounce = require('debounce');

export default {
  inject: {
    $validator: '$validator'
  },
  name: 'ComercialId',
  props: ['feature', 'type', 'permisos'],
  components: {
    Loader
  },
  data () {
    return {
      customErrors: {
        'tipo_establecimiento': null
      },
      loading: 3,
      id: null,
      detalles: {},
      detalles_ext: {},
      tipo_establecimiento_options: [],
      municipio_options: [],
      poblacion_options: [],
      provincias_options: [],
      categoria_gn_options: [],
      tipo_via_options: [],
      coordenadas_options: [],
      cnae_options: [],
      tipo_establecimiento_gn_options: [],
      names_suggestions: [],
      show_names: false,
      clickHappened: false,
      direccionCaldera: ''
    };
  },
  methods: {

    customLabelCNAE: function (opt) {
      return opt.id + ' - ' + opt.descripcion;
    },
    closedTipoEstablecimiento: function (val, id) {
      this.validTipoEstablecimiento();
    },
    validTipoEstablecimiento: function () {
      if (this.detalles['id_tipo_establecimiento_gn_' + this.type] !== undefined && this.detalles['id_tipo_establecimiento_gn_' + this.type] !== null && this.detalles['id_tipo_establecimiento_gn_' + this.type].id !== undefined && this.detalles['id_tipo_establecimiento_gn_' + this.type].id !== null) {
        this.customErrors['tipo_establecimiento'] = null;
        return true;
      }
      this.customErrors['tipo_establecimiento'] = 'El campo Tipo establecimiento es obligatorio.';
      return false;
    },
    loadNames: debounce(function (value) {
      if (value && !this.clickHappened) {
        var municipio = this.municipio_options.find(e => e.entity_name === this.detalles.municipio).zeus_codigo_municipio_ine;
        this.$http.get('streets/', {params: {zeus_codigo_municipio_ine: municipio, direccion__icontains: value.toUpperCase()}}).then(result => {
          this.names_suggestions = result.data.results;
          this.show_names = true;
        });
      } else {
        this.show_names = false;
      }
    }, 250),
    setElement: function (value) {
      if (value.street_name) {
        this.$set(this.detalles, 'nombre_via', value.street_name);
      }
      if (value.postal_code_address) {
        this.$set(this.detalles, 'codigo_postal', value.postal_code_address);
      }
      if (value.street_type) {
        this.$set(this.detalles, 'tipo_via', value.street_type.name_type);
      }
      if (value.zeus_codigo_poblacion_ine) {
        var p = this.poblacion_options.find(e => e.zeus_codigo_poblacion_ine === value.zeus_codigo_poblacion_ine);
        this.$set(this.detalles, 'codigo_poblacion_zeus', p.zeus_codigo_poblacion_ine);
      }

      this.show_names = false;
      this.clickHappened = true;

      var th = this;
      setTimeout(() => {
        th.clickHappened = false;
      }, 400);
    },
    hasPermision: function (p) {
      var rol = '';
      if (this.type === 'caldera') {
        rol = 'CALDERA CENTRALIZADA';
        return false;
      } else {
        rol = 'COMERCIAL';
      }
      return this.permisos[rol][p];
    },
    loadTipo: function (onMounted) {
      if (this.detalles['id_categoria_gn_' + this.type] && this.detalles['id_categoria_gn_' + this.type].id) {
        var params = {params: {not_paginated: true}};
        if (this.type === 'comercial') {
          params = {params: {not_paginated: true, ['id_categoria_gn_' + this.type]: this.detalles['id_categoria_gn_' + this.type].id}};
        }
        this.$http.get('tipos_' + this.type + '/', params).then(result => {
          this.tipo_establecimiento_gn_options = [{id: null, tipo: ''}].concat(result.data);
          this.loading = this.loading - 1;
        });
      } else {
        this.tipo_establecimiento_gn_options = [];
        this.loading = this.loading - 1;
      }
      if (!onMounted) {
        this.detalles.id_tipo_establecimiento_gn_comercial.id = null;
      }
    },
    loadMunicipio: function (onMounted) {
      if (this.detalles.codigo_provincia_zeus) {
        this.$http.get('geomunicipio/', {params: {not_paginated: true, cod_gas_provincia: this.detalles.codigo_provincia_zeus}}).then(result => {
          this.municipio_options = [{id: null, entity_name: ''}].concat(result.data);
          this.loading = this.loading - 1;
        });
        // this.detalles.codigo_postal = ''
        // Why? The postal code will ve validated once the form is saved. If it's invalid, we will know.
      } else {
        this.municipio_options = [];
        this.loading = this.loading - 1;
      }
      if (!onMounted) {
        this.detalles.codigo_municipio_zeus = null;
      }
    },
    loadPoblacion: function (onMounted) {
      if (this.detalles.codigo_municipio_zeus) {
        this.$http.get('geopoblacion/', {params: {not_paginated: true, cod_gas_municipio: this.detalles.codigo_municipio_zeus}}).then(result => {
          this.poblacion_options = [{id: null, entity_name: ''}].concat(result.data);
          this.loading = this.loading - 1;
        });
      } else {
        this.poblacion_options = [];
        this.loading = this.loading - 1;
      }
      if (!onMounted) {
        this.detalles.codigo_poblacion_zeus = null;
      }
    },
    cancel: function () {
      this.loading = 3;
      var id = this.feature.id.split('.')[1];
      if (this.type === 'caldera') {
        id = this.feature.properties.id;
      }
      this.$http.get(this.type + '/' + id + '/').then(result => {
        this.detalles = result.data;
        this.loadTipo(true);
        this.loadMunicipio(true);
        this.loadPoblacion(true);
      });
    },
    SetNewLocation: function () {

    },
    save: function (event, triggeredExternally = false, cb = false) {
      console.log('IDENTIFICACION');

      let errorsTipoEstablecimiento = !this.validTipoEstablecimiento();
      this.$validator.validate().then(result => {
        if (!result || errorsTipoEstablecimiento) {
          alert('Tienes algún error en el formulario');
        } else {
          this.loading = 1;
          if (this.detalles.codigo_provincia_zeus) {
            this.detalles.provincia = this.provincias_options.find(e => e.id === this.detalles.codigo_provincia_zeus).entity_name;
          } else {
            this.detalles.provincia = '';
          }
          if (this.detalles.codigo_municipio_zeus) {
            this.detalles.municipio = this.municipio_options.find(e => e.id === this.detalles.codigo_municipio_zeus).entity_name;
          } else {
            this.detalles.municipio = '';
          }
          if (this.detalles.codigo_poblacion_zeus) {
            this.detalles.poblacion = this.poblacion_options.find(e => e.id === this.detalles.codigo_poblacion_zeus).entity_name;
          } else {
            this.detalles.poblacion = '';
          }

          let fieldsUsedInIdentificacionTab = {
            id: this.detalles['id'],
            ['id_categoria_gn_' + this.type]: this.detalles['id_categoria_gn_' + this.type],
            ['id_tipo_establecimiento_gn_' + this.type]: this.detalles['id_tipo_establecimiento_gn_' + this.type],
            nombre: this.detalles['nombre'],
            codigo_cnae: this.detalles['codigo_cnae'],
            codigo_provincia_zeus: this.detalles['codigo_provincia_zeus'],
            provincia: this.detalles['provincia'],
            codigo_municipio_zeus: this.detalles['codigo_municipio_zeus'],
            municipio: this.detalles['municipio'],
            codigo_poblacion_zeus: this.detalles['codigo_poblacion_zeus'],
            poblacion: this.detalles['poblacion'],
            direccion_no_estructurada: this.detalles['direccion_no_estructurada'],
            codigo_postal: this.detalles['codigo_postal'],
            tipo_via: this.detalles['tipo_via'],
            nombre_via: this.detalles['nombre_via'],
            numero: this.detalles['numero'],
            anexo: this.detalles['anexo'],
            latitud_original: this.detalles['latitud_original'],
            longitud_original: this.detalles['longitud_original'],
            id_precision_coordenada: this.detalles['id_precision_coordenada'],
            in_service_mains_distance: this.detalles['in_service_mains_distance'],
            not_abandoned_mains_distance: this.detalles['not_abandoned_mains_distance'],
            high_press_main_in_service_dis: this.detalles['high_press_main_in_service_dis'],
            high_pressure_mains_distance: this.detalles['high_pressure_mains_distance']
          };

          console.log('IDENTIFICACION SAVE...', fieldsUsedInIdentificacionTab);
          this.$http.patch(this.type + '/' + this.feature.id.split('.')[1] + '/', fieldsUsedInIdentificacionTab).then(result => {
            console.log('...IDENTIFICACION SAVED');
            if (!triggeredExternally) { console.log('EMITTING IDENTIFICACION'); this.$emit('triggerComercialSave', 'identificacion'); }
            if (triggeredExternally && cb !== false) cb();
            if (this.type === 'comercial') {
              this.$emit('comercialSaved');
            } else if (this.type === 'caldera') {
              this.$emit('calderaSaved');
            }
            this.detalles = result.data;
            this.$emit('SetNewLocation');
            this.loading = 0;
          });
        }
      });
    }
  },
  created () {
    let th = this;
    Validator.extend('cod_postal', {
      getMessage (field, args) {
        return 'El código postal introducido no es válido.';
      },
      validate (value, args) {
        let regex = /^((0[1-9]|5[0-2])|[1-4][0-9])[0-9]{3}$/;

        // debugger
        let prov = th.detalles.codigo_provincia_zeus;
        // console.log(prov)

        // console.log(prov)
        return (regex.test(value) && value.indexOf(prov) === 0);
      }
    });
  },
  mounted: function () {
    this.loading = 3;
    var id = this.feature.id.split('.')[1];
    if (this.type === 'caldera') {
      this.loading = 4;
      id = this.feature.properties.id;
    }
    this.id = id;
    this.clickHappened = true;
    this.$http.get(this.type + '/' + id + '/').then(result => {
      this.detalles = result.data;

      var th = this;
      setTimeout(() => { th.clickHappened = false; }, 1000);

      Promise.all([
        this.$http.get('geoprovincia/', {params: {not_paginated: true}}),
        // this.$http.get('municipios/', {params: {not_paginated: true}}),
        // this.$http.get('poblaciones/', {params: {not_paginated: true}}),
        this.$http.get('categorias_gn_' + this.type + '/', {params: {not_paginated: true}}),
        this.$http.get('tipos_vias/', {params: {not_paginated: true}}),
        this.$http.get('precision_coordenadas/', {params: {not_paginated: true}}),
        this.$http.get('cnae/', {params: {not_paginated: true}})
      ]).then(results => {
        this.provincias_options = [{id: null, entity_name: ''}].concat(results[0].data);
        this.categoria_gn_options = [{id: null, categoria_gn_comercial: ''}].concat(results[1].data);
        this.tipo_via_options = [{id: null, name_type: ''}].concat(results[2].data);
        this.coordenadas_options = [{id: null, tipo_precision: ''}].concat(results[3].data);

        this.cnae_options = [{id: null, descripcion: ''}].concat(results[4].data);
        // this.cnae_options = this.cnae_options.map(function (e) {
        //   e.descripcion = e.id + ' - ' + e.descripcion
        //   return e
        // })

        this.loadTipo(true);
        this.loadMunicipio(true);
        this.loadPoblacion(true);
      });
      if (this.type === 'caldera') {
        this.$http.get('caldera_extendida/' + id + '/').then(result => {
          this.detalles_ext = result.data;

          var s = '';
          if (this.detalles_ext.caldera_centralizada === 'PRINCIPAL') {
            s = this.detalles.tipo_via;
            s = s + ' ' + this.detalles.nombre_via;
            s = s + ', ' + this.detalles.numero;
            if (this.detalles.anexo) {
              s = s + ', ' + this.detalles.anexo;
            }
            this.direccionCaldera = s;
            this.loading = this.loading - 1;
          } else if (this.detalles_ext.caldera_centralizada === 'SUMINISTRADA') {
            s = 'test';
            this.$http.get('caldera/' + id + '/principal/').then(response => {
              var caldera = response.body.caldera;
              s = caldera.tipo_via;
              s = s + ' ' + caldera.nombre_via;
              s = s + ', ' + caldera.numero;
              if (caldera.anexo) {
                s = s + ' ' + caldera.anexo;
              }
              s = s + ', ' + caldera.poblacion;
              s = s + ' ' + caldera.municipio;
              s = s + ' (' + caldera.provincia + ')';
              this.direccionCaldera = s;
              this.loading = this.loading - 1;
            });
          }
        });
      }
    });
  },
  computed: {
    direccionValidate: function () {
      var value = this.detalles.direccion_no_estructurada || (this.detalles.tipo_via && this.detalles.nombre_via && this.detalles.numero);
      return {required: !value};
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/Modules/Map/Details/comercial_identificacion.vue